// @ts-ignore
import { customElement, property } from 'lit/decorators.js';
import parentStyles from '../../base/outline-heading/outline-heading.css.lit';
// @ts-ignore
import componentStyles from './idb-heading-alt.css.lit';
import { OutlineHeading } from '../../base/outline-heading/outline-heading';
// @ts-ignore
import { classMap } from 'lit/directives/class-map.js';
// @ts-ignore
import { html, unsafeStatic } from 'lit/static-html.js';
// @ts-ignore
import { TemplateResult } from 'lit';

export type AllowedHeadingCapitalization =
  | 'capitalize'
  | 'uppercase'
  | 'lowercase'
  | 'none'
  | 'full-width'
  | 'full-size-kana';

export type HeadingYMargin =
  | '0px'
  | '4px'
  | '8px'
  | '12px'
  | '20px'
  | '24px'
  | '31px'
  | '56px';

export type HeadingWidth = | 'default' | '50' | '60' | '70' | '80';

/**
 * The Heading component.
 * @element idb-heading
 * @property capitalStyle
 * @property marginSize
 * @slot defaultSlot
 */

@customElement('idb-heading-alt')
export class IdbHeadingAlt extends OutlineHeading {
  static styles = [parentStyles, componentStyles];

  @property({ type: String, reflect: true, attribute: 'style-override' })
  styleOverride: string;

  /**
   * The text-transform property to use to select the capitalization (or not) of the heading
   */
  @property({ type: String, reflect: true, attribute: 'capital-style' })
  capitalStyle: AllowedHeadingCapitalization;

  /* Margin Style th only affects top and bottom margins. */
  @property({ type: String, reflect: true, attribute: 'margin-size' })
  marginSize: HeadingYMargin;


  /* Color Style for the heading text. */
  @property({ type: String, reflect: true, attribute: 'color' })
  color: string;

  /* Width for the heading text. */
  @property({ type: String, reflect: true, attribute: 'width' })
  width: HeadingWidth;

  render(): TemplateResult {
    const classes = {
      'outline-text': true,
      [`idb-text--${this.levelSize}`]: true,
      [`idb-width--${this.width}`]: true,
      [`idb-color--${this.color}`]: true,
      [`idb-font--${this.levelStyle}`]: true,
      'mobile': this.mobileController.isMobile,
      [`style-override--${this.styleOverride}`]: true,
    };
    return html`
      <${unsafeStatic(this.level as string)} class=${classMap(classes)}>
        <slot></slot>
      </${unsafeStatic(this.level as string)}>`;
  }
}
